import * as actionTypes from './types';
import { endpoints } from '../../api/endpoints';
import * as api from '../../api/base';
import { GENERIC_ERROR_MESSAGE } from '../../helpers/apiHelper';

export const getMyAccount = () => async (dispatch) => {
    try {
        const response = await api.get(endpoints.profile.account);
        if (response && response.status === 200) {
            return dispatch(getMyAccountSuccess(response.data));
        }
        else {
            return dispatch(getMyAccountFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));
        }
    } catch (e) {
        return dispatch(updateMyAccountFail(e?.message || GENERIC_ERROR_MESSAGE));
    }
};

const getMyAccountSuccess = (response) => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_DATA_SUCCESS,
        payload: response
    };
};

const getMyAccountFail = (response) => {
    return {
        type: actionTypes.RESPONSE_STATE_FAIL,
        payload: response
    };
};

export const updateMyAccount = (data) => async (dispatch) => {
    const {
        id,
        type,
        email,
        firstName,
        lastName,
        organisationId,
        officeId,
        license,
        active,
        newsletter,
        agreement,
    } = data;
    try {
        const response = await api.put(endpoints.profile.account,
            {
                email: email,
                isActive: active,
                lockoutEnabled: true,
                firstName: firstName,
                lastName: lastName,
                roleNames: [type],
                agreedToTandS: agreement,
                licenseId: license,
                officeId: officeId,
                optInNewsletter: newsletter,
                organisationId: organisationId

            });
        if (response && response.status === 200) {
            await dispatch(getMyAccount(id));
            return dispatch(updateMyAccountSuccess("Account details has been updated successfully"));
        }
        else {
            return dispatch(updateMyAccountFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));
        }
    } catch (e) {
        return dispatch(updateMyAccountFail(e?.message || GENERIC_ERROR_MESSAGE));
    }
};

const updateMyAccountSuccess = (response) => {
    return {
        type: actionTypes.RESPONSE_STATE_SUCCESS,
        payload: response
    };
};

const updateMyAccountFail = (response) => {
    return {
        type: actionTypes.RESPONSE_STATE_FAIL,
        payload: response
    };
};

export const resetMyAccount = () => {
    return {
      type: actionTypes.RESET_MY_ACCOUNT_DATA,
    }
}

